<template>
    <div>
        <div class="mc-option hover:tw-opacity-75 tw-cursor-pointer" :class="{'tw-shadow-light tw-font-semibold': answer.question_option_id === option.id, 'tw-opacity-25': answer.question_option_id && answer.question_option_id !== option.id}" @click="setQuestionAnswer(option)" v-for="(option, index) in question.question_options" :key="option.id">
            <div class="mc-answer">{{ answerLetter(index) }}</div>
            <h2>{{ option.value }}</h2>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        name: "MultipleChoice",

        props: ['question'],

        computed: {
            ...mapState('quiz',
                ['new_answer']
            ),

            answer: {
                get() {
                    let answer = this.$store.getters['quiz/getQuestionProgress'](this.question.id);

                    if(typeof answer !== "undefined") {
                        return answer;
                    }

                    return this.new_answer;
                },

                set(value) {
                    let answer = this.$store.getters['quiz/getQuestionProgress'](this.question.id);

                    if(typeof answer !== "undefined") {
                        answer.question_option_id = value;
                    } else {
                        this.$store.commit('quiz/setNewAnswer', {value: value, type: this.question.type});
                        this.$forceUpdate();
                    }

					this.$store.commit('quiz/setCurrentAnswer', value);
                }
            }
        },

        data() {
            return {
                question_answer: [],
                answers:[],
            }
        },

        methods: {
            // new:
            setQuestionAnswer(option) {
                    this.$store.commit('quiz/removeAnswerConfirmation');

                    this.answer = option.id;
            },

            answerLetter(key) {
                switch(key) {
                    case 0:
                        return 'A';
                    case 1:
                        return 'B';
                    case 2:
                        return 'C';
                    case 3:
                        return 'D';
                    case 4:
                        return 'E';
                    case 5:
                        return 'F';
                    case 6:
                        return 'G';
                    case 7:
                        return 'H';
                    case 8:
                        return 'I';
                    case 9:
                        return 'J';
                    case 10:
                        return 'K';
                    case 11:
                        return 'L';
                    case 12:
                        return 'M';
                    case 13:
                        return 'N';
                    case 14:
                        return 'O';
                    case 15:
                        return 'P';
                    case 16:
                        return 'Q';
                    case 17:
                        return 'R';
                    case 18:
                        return 'S';
                    case 19:
                        return 'T';
                    case 20:
                        return 'U';
                    case 21:
                        return 'V';
                    case 22:
                        return 'W';
                    case 23:
                        return 'X';
                    case 24:
                        return 'Y';
                    default:
                        return 'Z';
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    .quiz-wrapper {
        .mc-option {
            @apply tw-flex tw-rounded-lg tw-overflow-hidden tw-border-2 tw-border-gray-200 tw-mb-4;
            min-height: 55px;

            .mc-answer {
                @apply tw-flex tw-items-center tw-justify-center tw-text-2xl tw-font-semibold tw-text-gray-800 tw-bg-gray-100;
                flex-basis: 50px;
            }

            h2 {
                @apply tw-flex-1 tw-text-gray-600 tw-text-base tw-flex tw-items-center tw-px-3 tw-py-1;
				@apply tw-mb-0 tw-leading-relaxed #{!important};
            }
        }
    }
</style>